import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

type LockFn = (
  name: string,
  acquireTimeout: number,
  fn: () => Promise<unknown>
) => Promise<unknown>;

// Custom lock with a timeout cap so cross-tab lock contention never freezes the page.
const customLock: LockFn = (name, acquireTimeout, fn) => {
  if (typeof navigator !== 'undefined' && 'locks' in navigator) {
    return navigator.locks.request(name, { timeout: acquireTimeout }, async (lock) => {
      if (!lock) {
        throw new Error(`Lock timeout exceeded for ${name}`);
      }
      return fn();
    });
  }
  return fn();
};

export const supabase: SupabaseClient = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    lock: customLock,
  },
});